<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="8" :sm="24">
            <a-form-item label="MPS版本">
              <a-input v-model="ruleForm.version" disabled/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="月度计划">
              <a-input v-model="ruleForm.mpName" disabled/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="版本">
              <a-input v-model="ruleForm.mpVersion" disabled/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="参数版本">
              <a-input v-model="ruleForm.parameterVersion" disabled/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="完成日期">
              <a-input v-model="ruleForm.dataCompletionDate" disabled/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">

          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <!-- <a-row>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('报检需求')" v-hasPermi="['mdm:mdmUomConversions:export']">报检需求</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('净需求')" v-hasPermi="['mdm:mdmUomConversions:export']">净需求</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('供应明细')" v-hasPermi="['mdm:mdmUomConversions:export']">供应明细</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('物料分配比例')" v-hasPermi="['mdm:mdmUomConversions:export']">物料分配比例</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('供应商产能负荷')" v-hasPermi="['mdm:mdmUomConversions:export']">供应商产能负荷</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('计划单调整')" v-hasPermi="['mdm:mdmUomConversions:export']">计划单调整</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('产能均衡')" v-hasPermi="['mdm:mdmUomConversions:export']">产能均衡</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('计划结果')" v-hasPermi="['mdm:mdmUomConversions:export']">计划结果</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('计划执行')" v-hasPermi="['mdm:mdmUomConversions:export']">计划执行</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('例外明细')" v-hasPermi="['mdm:mdmUomConversions:export']">例外明细</a-button>
        </a-col>
      </a-row> -->

      <a-row>
        <a-col :md="24" :sm="24">
          <span>计划参数</span>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('发货预测基础数据')">发货预测基础数据</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('供应商产能')">供应商产能</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('安全库存比例')">安全库存比例</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('MPS基础数据')">MPS基础数据</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('标准分配比例')">标准分配比例</a-button>
        </a-col>
        <a-col :md="24" :sm="24">
          <span>需求源头</span>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('销售预测')">销售预测</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('发货预测')">发货预测</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('月度计划')">月度计划</a-button>
        </a-col>
        <a-col :md="24" :sm="24">
          <span>需求运算模块</span>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('标准报检需求')">标准报检需求</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('月度报检需求')">月度报检需求</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('净需求')">净需求</a-button>
        </a-col>
        <a-col :md="24" :sm="24">
          <span>供应商订单分配</span>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('本期分配比例')">本期分配比例</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('供应商订单明细')">供应商订单明细</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('供应商产能负荷')">供应商产能负荷</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('计划单调整')">计划单调整</a-button>
        </a-col>
        <a-col :md="24" :sm="24">
          <span>MPS均衡</span>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('每周产能均衡')">每周产能均衡</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('SKU计划结果')">SKU计划结果</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('供应商订单明细')">供应商订单明细</a-button>
        </a-col>
        <a-col :md="24" :sm="24">
          <span>MPS执行</span>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('计划单发放')">计划单发放</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('例外明细')">例外明细</a-button>
        </a-col>
        <a-col class="menu_bt" :md="6" :sm="24">
          <a-button @click="handleGoPage('查看发放结果')">查看发放结果</a-button>
        </a-col>
      </a-row>
    </div>

  </ls-table-layout>
</template>

<script>
import { ApiScpMpsPlansDetail } from '@/api/mps/basic-data/mps-option.js'
 import moment from 'moment';
 import StartWeeklyBalancing from './components/StartWeeklyBalancing';
export default {
  // eslint-disable-next-line
  name: 'detail', // name要和菜单路由保存一致; 新页面不要建这种容易重复的name
  components: {
    StartWeeklyBalancing
  },
  computed: {
  // 其他计算属性
  // ...
  formattedParams () {
    return {
      monthStart: moment(this.currentPeriod).format("YYYYMM")
      // monthEnd: moment(this.baseInfo.forecastPeriodTo).format("YYYYMM")
    };
  }
},
  data () {
    return {
      ruleForm: {
        id: '',
        dataCompletionDate: '',
        mpName: '',
        mpVersion: '',
        parameterVersion: '',
        version: ''
      },
      moment: moment, // 在 data 中创建 moment 实例
      currentPeriod: '',
      isEdit: false,
      currentId: "",
      lookUpCode: '',
      // 表格多选
      selectedRowKeys: []
    }
  },
  created () {
   // this.getLastSalesForecast()
 //  this.getLookUpCode('SOP_PROCESS_STATU') /${this.ruleForm.id }
    this.ruleForm.id = this.$route.params.id;
  },
  mounted () {
    this.getPageDetail()
  },
  methods: {
    handleGoPage (type) {
      switch (type) {
          case '标准报检需求':
          if (!this.ruleForm.version) {
                this.$message.error('查找的数据不存在')
                return
              }
            this.$router.push({
              name: 'mps-Inspection-requirements',
              query: { id: this.ruleForm.version }
            });
            break;
            case '供应商产能':
            if (!this.ruleForm.capacityBasicDataId || !this.ruleForm.capacityVersionCode) {
                this.$message.error('查找的数据不存在')
                return
              }
            this.$router.push({
              path: `/supplier-capacity/detail?id=${this.ruleForm.capacityBasicDataId}&description=${this.ruleForm.capacityDescription}&=versionCode${this.ruleForm.capacityVersionCode}`
            });
            break;
            case '发货预测基础数据':
            if (!this.ruleForm.sopDfcBasicDataId || !this.ruleForm.sopDfcBasicVersion) {
                this.$message.error('查找的数据不存在')
                return
              }
            this.$router.push({
              path: `/shipmentForecastSettings/versionDetail?id=${this.ruleForm.sopDfcBasicDataId}&description=${this.ruleForm.sopDfcBasicDescription}&versionCode=${this.ruleForm.sopDfcBasicVersion}`
            });
            break;
            case '发货预测':
            if (!this.ruleForm.shipmentForecastVersion) {
                this.$message.error('查找的数据不存在')
                return
              }
            this.$router.push({
              path: `/scp/producingAndMarketing/shipmentForecast`,
              query: { shipmentForecastVersion: this.ruleForm.shipmentForecastVersion }

            });
            break;
            case '销售预测':
            if (!this.ruleForm.sfcName || !this.ruleForm.sfcVersion) {
                this.$message.error('查找的数据不存在')
                return
              }
            this.$router.push({
              path: `/salesForecast/detail/${this.ruleForm.sfcName}/${this.ruleForm.sfcVersion}/${this.ruleForm.sfcDescription}`
            });
            break;
            case '月度计划':
            if (!this.ruleForm.mpName || !this.ruleForm.mpVersion) {
                this.$message.error('查找的数据不存在')
                return
              }
            this.$router.push({
              path: `/monthly-plan/monthly-plan-workDesk`,
              query: { mpName: this.ruleForm.mpName, mpVersion: this.ruleForm.mpVersion }
            });
            break;
            case '月度报检需求':
            if (!this.ruleForm.version) {
                this.$message.error('查找的数据不存在')
                return
              }
            this.$router.push({
              path: `/mps-Inspection-requirements/inspectionAdjustment/${this.ruleForm.version}`
            });
            break;
            case '安全库存比例':
            if (!this.ruleForm.id || !this.ruleForm.safeStockDescription) {
                this.$message.error('查找的数据不存在')
                return
              }
            this.$router.push({
              path: `/safety-stock-ratio/detail?id=${this.ruleForm.id}&description=${this.ruleForm.safeStockDescription}&versionCode=${this.ruleForm.safeStockVersion}`
            });
            break;
            case 'MPS基础数据':
              if (!this.ruleForm.mpsBasicDataId) {
                this.$message.error('查找的数据不存在')
                return
              }
            this.$router.push({
              path: `/basic-info-index/detail?id=${this.ruleForm.mpsBasicDataId}&description=${this.ruleForm.mpsBasicDescription}&versionCode=${this.ruleForm.mpsBasicVersion}`
            });
            break;
            case '标准分配比例':
            if (!this.ruleForm.assignmentSetId) {
                this.$message.error('查找的数据不存在')
                return
              }
            this.$router.push({
              path: `/mps/mps-basic-info/product-source-rules`,
              query: { assignmentSetId: this.ruleForm.assignmentSetId }
            });
            break;
          case '净需求':
          if (!this.ruleForm.version) {
                this.$message.error('查找的数据不存在')
                return
              }
            this.$router.push({
              path: '/mps/mps-result/mps-net-requirement',
              query: { id: this.ruleForm.version }
            });
            break;
          case '供应商订单明细':
          if (!this.ruleForm.version) {
                this.$message.error('查找的数据不存在')
                return
              }
          this.$router.push({
            path: '/mps/mps-result/mps-supply-details',
            query: { id: this.ruleForm.version }
          });
            break;
        case '供应商产能负荷':
        if (!this.ruleForm.version) {
                this.$message.error('查找的数据不存在')
                return
              }
        this.$router.push({
          path: '/mps/mps-result/supplier-capacity-load',
          query: { id: this.ruleForm.version }
        });
        break;
        case '本期分配比例':
        if (!this.ruleForm.id) {
                this.$message.error('查找的数据不存在')
                return
              }
        this.$router.push({
          path: '/mps/mps-result/material-allocation-ratio',
          query: { id: this.ruleForm.id }
        });
        break;
        case '计划单调整':
        if (!this.ruleForm.version) {
                this.$message.error('查找的数据不存在')
                return
              }
        this.$router.push({
          path: '/mps/mps-result/mps-plan-adjustment',
          query: { mpsVersion: this.ruleForm.version }
        });
        break;
        case 'SKU计划结果':
        if (!this.ruleForm.version) {
                this.$message.error('查找的数据不存在')
                return
              }
        this.$router.push({
          path: '/mps/mps-result/mps-plan-results',
          query: { id: this.ruleForm.version }
        });
        break;
        case '计划单发放':
        if (!this.ruleForm.version) {
                this.$message.error('查找的数据不存在')
                return
              }
        this.$router.push({
          path: '/mps/mps-result/mps-plan-execution',
          query: { id: this.ruleForm.version }
        });
        break;
        case '例外明细':
        if (!this.ruleForm.version) {
                this.$message.error('查找的数据不存在')
                return
              }
        this.$router.push({
          path: '/mps/mps-result/mps-exception-details',
          query: { id: this.ruleForm.version }
        });
        break;
        case '查看发放结果':
        if (!this.ruleForm.version) {
                this.$message.error('查找的数据不存在')
                return
              }
        this.$router.push({
          path: '/mps-plan-execution/result',
          query: { version: this.ruleForm.version }
        });
        break;
        case '每周产能均衡':
        if (!this.ruleForm.version) {
                this.$message.error('查找的数据不存在')
                return
              }
        this.$router.push({
          path: '/mps/mps-result/mps-capacity-balance',
          query: { id: this.ruleForm.version }
        });
        break;
          default:
            // 如果没有匹配的类型，可以在此处理默认情况
            break;
        }
    },
    // 编辑-保存
    getPageDetail () {
      ApiScpMpsPlansDetail(this.ruleForm.id).then((response) => {
            if (response.code === 200) {
              this.$message.success('查询成功')
             this.ruleForm = response.data
            } else {
              this.$message.error(response.msg)
            }
          })
        }
  }
}
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}/deep/.ant-select{
width: 150px;
}.menu_bt{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;

}.ant-btn{
width: 150px;
}
</style>
